import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const Login = () => {
  const { user, login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/member"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      navigate(u.role === "admin" ? "/admin" : "/member");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="grid min-h-[calc(100vh-140px)] place-items-center bg-brand-green px-5 py-12 grain">
      <div className="w-full max-w-md rounded-3xl border-2 border-brand-ink bg-white p-8 shadow-brutal-lg">
        <h1 className="font-display text-4xl font-black tracking-tight">{t("login_title")}</h1>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
          <div>
            <label className="text-sm font-semibold">{t("form_email")}</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded-xl border-2 border-brand-ink bg-brand-cream px-4 py-3 outline-none focus:ring-2 focus:ring-brand-green" />
          </div>
          <div>
            <label className="text-sm font-semibold">{t("password")}</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full rounded-xl border-2 border-brand-ink bg-brand-cream px-4 py-3 outline-none focus:ring-2 focus:ring-brand-green" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-full border-2 border-brand-ink bg-brand-ink py-3 font-bold text-brand-yellow hover-brutal disabled:opacity-60">
            {loading ? "..." : t("nav_login")}
          </button>
        </form>
        <Link to="/register" className="mt-5 block text-center text-sm font-semibold text-brand-greendark hover:underline">{t("no_account")}</Link>
      </div>
    </div>
  );
};

export default Login;
